import { authConfig } from './auth';
import { defineClient } from '@zg-rentals/auth-react/client';

export const Auth = defineClient(authConfig);

export const { useAuth } = Auth;
